<p>notification-template-email-edit works!</p>
